import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { SelectedUserPreferences } from 'src/app/core/model/reinsurer.model'
import { environment } from '../../../environments/environment'
import { ApiResponse } from '../model/api.model'
import { catchAndHandleError, mapToMaybeData } from '../util'
import { ProgramEvents } from 'src/app/program-events/model/program-events.model'

@Injectable({
  providedIn: 'root',
})
export class ProgramEventsService {
  private httpClient = inject(HttpClient)

  private httpOptions = {
    headers: new HttpHeaders({
      // 'Accept-Encoding': 'gzip, compress, br',
      'Content-Type': 'application/json',
      References: 'Expand',
    }),
  }

  saveOrUpdateProgramEvents(programEvents: ProgramEvents): ApiResponse<ProgramEvents> {
    const url = `${environment.internalApi.base}${environment.internalApi.study}${environment.internalApi.programEvents}`

    return this.httpClient
      .post<ProgramEvents>(url, programEvents, this.httpOptions)
      .pipe(mapToMaybeData(), catchAndHandleError('Save or Update Program Events'))
  }
}
